import { FC } from 'react';
import { TextFieldFormikWrapper } from 'core/components/forms/TextField';
import { FormikProps } from 'formik';
import { ITextField } from 'core/components/forms/TextField/TextField';
import { ErrorIcon } from 'assets/img';
import './style.scss';

interface IInputFieldFormProps {
  formikProps: FormikProps<any>;
}

export const InputFieldForm: FC<IInputFieldFormProps & ITextField> = (props) => {
  const { formikProps, ...rest } = props;

  return (
    <TextFieldFormikWrapper
      {...rest}
      formikProps={formikProps}
      children={<>
        {rest.children}
        <ErrorIcon className={'error-icon'}/>
      </>}
      onBlur={() => {
        if (!formikProps.touched[rest.name]) {
          formikProps.setFieldTouched(rest.name);
        }
      }}
    />
  );
};

